export default __webpack_public_path__ + "static/media/sec5.efceeba5.svg";